import React from 'react';
import WindowedSelect from 'react-windowed-select';
import { selectStyles } from '../leaseGeneralInvoiceReceipt/formUtils';
import { FULL_REVERSE, MAX_REMARKS, fmt3 } from './reverseHelpers';

const selectProps = { menuPortalTarget: document.body, menuPlacement: 'auto', menuShouldScrollIntoView: false, styles: selectStyles };

const Row = ({ label, children }) => (
    <div className="d-flex align-items-start mb-2">
        <label className="form-label pt-1" style={{ minWidth: 150 }}>{label}</label>
        <div style={{ width: 300 }}>{children}</div>
    </div>
);

/**
 * @param {{
 *   panel: { transactionType: string, account: object|null, amount: string, remarks: string },
 *   selectedLine: object|null, typeOptions: object[], accountOptions: object[], disabled: boolean,
 *   onChange: (patch: object) => void, onAllocate: () => void, onReset: () => void
 * }} props
 */
const AllocationPanel = ({ panel, selectedLine, typeOptions, accountOptions, disabled, onChange, onAllocate, onReset }) => {
    const isFull = panel.transactionType === FULL_REVERSE;
    return (
        <div className="cost-center-section mt-3">
            <div className="d-flex slide-header"><div className="param-label pt-1">Allocation Details</div></div>
            <div className="border-box2 p-3">
                <div className="d-flex flex-wrap gap-5">
                    <div>
                        <Row label="Transaction Type">
                            <WindowedSelect
                                {...selectProps}
                                isDisabled={disabled}
                                placeholder="--Transaction Type--"
                                value={typeOptions.find((o) => o.label === panel.transactionType) || null}
                                options={typeOptions}
                                onChange={(o) => onChange({ transactionType: o?.label || '' })}
                            />
                        </Row>
                        <Row label="Refund Account">
                            <WindowedSelect
                                {...selectProps}
                                isClearable
                                isDisabled={disabled}
                                placeholder="--Select--"
                                value={panel.account}
                                options={accountOptions}
                                onChange={(o) => onChange({ account: o || null })}
                            />
                        </Row>
                        <Row label="Selected line amount">
                            <input className="p-2 form-control text-end" disabled value={selectedLine ? fmt3(selectedLine.amountPaid) : ''} />
                        </Row>
                        <Row label="Amount">
                            <input
                                type="number"
                                step="0.001"
                                min="0"
                                className="p-2 form-control text-end"
                                disabled={disabled || isFull}
                                value={panel.amount}
                                onChange={(e) => onChange({ amount: e.target.value })}
                            />
                        </Row>
                    </div>
                    <div>
                        <Row label="Narration / Remarks">
                            <textarea
                                className="p-2 form-control"
                                rows={5}
                                maxLength={MAX_REMARKS}
                                disabled={disabled}
                                value={panel.remarks}
                                onChange={(e) => onChange({ remarks: e.target.value })}
                            />
                        </Row>
                        <div className="d-flex gap-2" style={{ marginLeft: 150 }}>
                            <button type="button" className="mainbtn" disabled={disabled} onClick={onAllocate}>Allocate</button>
                            <button type="button" className="mainbtnSecondary" disabled={disabled} onClick={onReset}>Reset</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllocationPanel;
